import { useCallback, useEffect, useState } from "react";
import { Route, Routes, Outlet, useLocation, Location } from "react-router-dom";
import { MainLayout } from "@/layouts/Layout";
import { AdminPage } from "@/pages/Admin/Admin/Admin.page";
import { InputPage } from "@/pages/Company/Input/Input.page";
import { ConfigReferenciasPage } from "@/pages/Company/ConfigReferencias/ConfigReferencias.page";
import { DashboardPage } from "@/pages/Company/Dashboard/Dashboard.page";
import { LoginPage } from "@/pages/Login.page";
import { RegisterPage } from "@/pages/Register.page";
import { NotFoundPage } from "@/pages/Company/NotFound.page";
import { ListPage } from "@/pages/Company/List/List.page";
import { CustomFactoresPage } from "@/pages/Company/CustomFactores/CustomFactores.page";
import { EmpresaPage } from "@/pages/Company/Empresa/Empresa.page";
import { EmpresaInputPage } from "@/pages/Company/EmpresaInput/EmpresaInput.page";
import { ResetPasswordPage } from "@/pages/ResetPassword.page";
import { OrganizacionPage } from "@/pages/Company/Organizacion/Organizacion.page";
import { ProyectosPage } from "@/pages/Company/Proyectos/Proyectos.page";
import { ProyectoPage } from "@/pages/Company/Proyecto/Proyecto.page";
import { ErrorBoundary } from "@/components/ui/ErrorBoundary";

function AppRoutes(props: { readonly displayLocation: Location; }) {
	// const { user } = useAuth();

	return (
		<Routes location={props.displayLocation}>
			<Route path="/" element={<LoginPage />} />
			<Route path="/login" element={<LoginPage />} />
			<Route path="/register" element={<RegisterPage />} />
			<Route path="/reset-password" element={<ResetPasswordPage />} />

			<Route
				element={
					<MainLayout>
						<ErrorBoundary>
							<Outlet />
						</ErrorBoundary>
					</MainLayout>
				}
			>
				<Route path="/admin">
					<Route index element={<AdminPage />} />
					<Route path="*" element={<NotFoundPage />} />
				</Route>
				<Route path="/user">
					<Route index element={<ListPage />} />
					<Route path="input/:inputId" element={<InputPage />} />
					<Route path="config" element={<ConfigReferenciasPage />} />
					<Route path="configFactores" element={<CustomFactoresPage />} />
					<Route path="dashboard" element={<DashboardPage />} />
					<Route path="empresa" element={<EmpresaPage />} />
					<Route path="empresa/input/:anio" element={<EmpresaInputPage />} />

					<Route path="organizacion" element={<OrganizacionPage />} />
					<Route path="proyectos" element={<ProyectosPage />} />
					<Route path="proyectos/:proyectoId" element={<ProyectoPage />} />

					<Route path="*" element={<NotFoundPage />} />
				</Route>
			</Route>
		</Routes>
	);
}

export default function TransitionRouter() {
	const location = useLocation();

	const [displayLocation, setDisplayLocation] = useState(location);
	const [transitionStage, setTransitionStage] = useState("fadeIn");

	const onAnimationEnd = useCallback(() => {
		if (transitionStage === "fadeOut") {
			setTransitionStage("fadeIn");
			setDisplayLocation(location);
		}
	}, [location, transitionStage]);

	useEffect(() => {
		// if (
		// 	location.pathname === "/inicio" &&
		// 	displayLocation.pathname === "/login"
		// ) {
		// 	//Cambiamos de router, asi que no vamos a usar animacion
		// 	//TO DO Estaria bien que la primera vez que se renderiza un router el mismo use una animacion?
		// 	setDisplayLocation(location);
		// 	return;
		// }

		if (location !== displayLocation) setTransitionStage("fadeOut");

		// A veces, onAnimationEnd no se llama si se cambia de ruta muy rápido.
		//Esto asegura que se llame, y como solo afecta si estoy en fadeOut, no deberia causar problemas
		setTimeout(onAnimationEnd, 400);
	}, [location, displayLocation, onAnimationEnd]);

	return (
		<div
			className={`${transitionStage} TransitionRoutes`}
			onAnimationEnd={onAnimationEnd}
		>
			<AppRoutes displayLocation={displayLocation} />
		</div>
	);
}
